export default __webpack_public_path__ + "static/media/pokeball.87e3bdf5.png";